import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LogOut, ExternalLink } from "lucide-react";

export function AdminNav() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (path) =>
    `text-sm tracking-wide transition-colors ${
      loc.pathname === path ? "text-[#0B1220] font-medium" : "text-[#5C6678] hover:text-[#0B1220]"
    }`;

  return (
    <header className="sticky top-0 z-30 border-b border-[#D5DEEE] bg-[#F4F8FF]/90 backdrop-blur">
      <div className="px-6 md:px-10 max-w-[1400px] mx-auto flex items-center justify-between h-16">
        <div className="flex items-center gap-8">
          <Link to="/admin" className="flex flex-col leading-none">
            <span className="font-heading text-lg text-[#0B1220] leading-tight">Advanced Post Graduate Excellence</span>
          </Link>
          <nav className="flex items-center gap-6">
            <Link to="/admin" data-testid="adminnav-courses" className={linkCls("/admin")}>Corsi</Link>
            <Link to="/admin/leads" data-testid="adminnav-leads" className={linkCls("/admin/leads")}>Lead</Link>
            <Link to="/admin/blog" data-testid="adminnav-blog" className={linkCls("/admin/blog")}>Blog</Link>
            <Link to="/admin/sito" data-testid="adminnav-settings" className={linkCls("/admin/sito")}>Sito</Link>
          </nav>
        </div>
        <div className="flex items-center gap-4">
          <a href="/" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#5C6678] hover:text-[#0B1220]">
            Vedi sito <ExternalLink className="h-3.5 w-3.5" />
          </a>
          <button
            data-testid="admin-logout"
            onClick={() => { logout(); nav("/login"); }}
            className="inline-flex items-center gap-2 border border-[#0B1220] text-[#0B1220] hover:bg-[#0B1220] hover:text-[#F4F8FF] transition-colors rounded-sm px-4 py-2 text-sm font-medium"
          >
            <LogOut className="h-4 w-4" /> Esci
          </button>
        </div>
      </div>
    </header>
  );
}
